import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import React, { useState } from 'react';

const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        flexDirection: 'column',
        marginBottom: theme.spacing(2),
        opacity: '95%'
    },
    white: {
        color: 'white'
    }
}));

interface AboutPageProps {
    onBackgroundChange: () => void; // Prop for changing background
}

const AboutPage: React.FC<AboutPageProps> = ({ onBackgroundChange }) => {
    const classes = useStyles();

    const maxClicks = 10;
    const [clickCount, setClickCount] = useState(0);

    // Function to handle background image change after 10 clicks
    const handleAboutMeClick = () => {
        setClickCount((prevCount) => {
            const newCount = prevCount + 1;
            if (newCount >= maxClicks) {
                setClickCount(0); // Reset click count
                onBackgroundChange();
                console.log("Easter egg activation successful!")
            }
            return newCount;
        });
    };

    return (
        <>
            <h1>About This Project</h1>
            <Paper className={classes.paper}>
                <p>
                    This project is a comprehensive health monitoring system designed to collect, display, and analyze various vital signs and environmental factors. The system focuses on improving patient care by capturing real-time data through IoT devices and presenting it in a user-friendly dashboard.
                </p>

                <h2>Key Features</h2>
                <ul>
                    <li>
                        <strong>OLED Display Control</strong>: Users can remotely control the OLED display on IoT devices. This is achieved through a simple and intuitive control panel, with settings stored both locally and synced via AWS.
                    </li>
                    <li>
                        <strong>Health Monitoring</strong>:
                        <ul>
                            <li><strong>Blood Pressure</strong>: Real-time monitoring of systolic and diastolic pressure, as well as heart rate. The system provides intuitive feedback on the user's health status using dynamic charts and status indicators.</li>
                            <li><strong>Sensor Data</strong>: Environmental data, such as temperature, humidity, atmospheric pressure, and blood oxygen levels (SpO2), is captured and displayed in charts for easy visualization.</li>
                        </ul>
                    </li>
                    <li>
                        <strong>AWS Integration</strong>:
                        <ul>
                            <li>The system utilizes AWS services for its backend, including DynamoDB for data storage and Lambda functions for backend logic. The API Gateway ensures seamless communication between the frontend and backend.</li>
                            <li><strong>Real-time Data</strong>: Data is collected and transmitted in real-time using AWS AppSync GraphQL subscriptions, ensuring the dashboard stays up to date with the latest measurements.</li>
                        </ul>
                    </li>
                    <li><strong>Customizable Alerts</strong>: Users can configure the system to send email alerts to doctors or family members when specific health conditions are detected, ensuring timely medical intervention.</li>
                </ul>

                <h2>Technology Stack</h2>
                <ul>
                    <li><strong>Frontend</strong>: React (with TypeScript) for the interactive UI, Material-UI for design components, and Recharts for data visualization.</li>
                    <li><strong>Backend</strong>: AWS Amplify for easy management, AWS Lambda for serverless processing, and DynamoDB for fast, scalable data storage.</li>
                    <li><strong>Communication</strong>: API Gateway for secure communication between the client and backend services.</li>
                </ul>

                <h2 id="about-me" onClick={handleAboutMeClick}>About Me</h2>
                <p>{'Powered By '}
                    <a href='https://blog.reilkay.com'>
                        Reilkay.
                    </a>
                </p>
                <p className={classes.white}>{clickCount}</p>
            </Paper >
        </>
    );
};

export default AboutPage;
